window.is_ie = /MSIE|Trident/i.test(navigator.userAgent);
window.is_iphone = /iPhone|iPod/i.test(navigator.userAgent);
window.is_ios = /iPad|iPhone|iPod/.test(navigator.userAgent);
window.is_touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
Colors.Helpers = (function() {
  var touchDevice = false;

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return window.is_touch_device;
  }
  return {
    setTouch: setTouch,
    isTouch: isTouch
  };
})();
Colors.LibraryLoader = (function() {
  var types = {
    link: 'link',
    script: 'script'
  };

  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };

  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

  var libraries = {
    youtubeSdk: {
      tagId: 'youtube-sdk',
      src: 'https://www.youtube.com/iframe_api',
      type: types.script
    },
    plyrShopifyStyles: {
      tagId: 'plyr-shopify-styles',
      src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
      type: types.link
    },
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];

    if (!library) return;
    if (library.status === status.requested) return;

    callback = callback || function() {};
    if (library.status === status.loaded) {
      callback();
      return;
    }

    library.status = status.requested;

    var tag;

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }

    tag.id = library.tagId;
    library.element = tag;

    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load
  };
})();
Colors.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

Colors.Sections.prototype = _.assignIn({}, Colors.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

Colors.Variants = (function() {
  
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  
  function Variants(options) {
  
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    
    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },
    
    

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;

      /*
      if (!$('body').hasClass('template-index')) {
        window.history.replaceState({path: newurl}, '', newurl);
      }
      */
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();

document.addEventListener('DOMContentLoaded', () => {
  
  $.getJSON('/cart.js', function(cart) {
    $('p#cart-item-count').text(cart.item_count);
  } );
  var productJson;
  if( $('#LSG-Buy-Box').length){
    $('.inactive-box-block').first().addClass('active-box-block');
    $('.inactive-box-block').first().removeClass('inactive-box-block');
    
    productJson = [...document.querySelectorAll('.active-box-block .ProductJson')];
    
    if (productJson.length > 0 ) {
      productJson.forEach((product) => {
        var variantSKU;
        var productInfo;
        var radioButtons;
        var variantPrice;
        var variantSubsPrice;
        variantSKU = document.querySelector('.active-box-block span.variant-sku');
        variantPrice = document.querySelector('.active-box-block .product-price');
        variantSubsPrice = document.querySelector('.active-box-block .product-price-recharge');
        
        productInfo = JSON.parse(product.innerHTML);
       
        radioButtons = document.querySelector('.active-box-block .single-option-radio');
        var inputSelects;
        var orderOption = [...document.querySelectorAll('.active-box-block .recharge-subs-options')];
        
        if (radioButtons !== null) {
          inputSelects = [...document.querySelectorAll('.active-box-block .single-option-radio')];
        } else {
          inputSelects = [...document.querySelectorAll('.active-box-block .single-option-selector__radio')];
        }
        var inputValues = [];
        var optionValues = [];
        let count = 0;
        orderOption.forEach((input) => {
         
          input.addEventListener('change', (evt) => {
            $('.recharge-subs-options').each(function() {
              $(this).removeAttr('checked');
              $(this).prop('checked', false);
              var newid = $(this).attr('id');
              $('.active-box-block #'+newid+'-2').removeAttr('checked');
              $('.active-box-block #'+newid+'-2').prop('checked', false);
              
            });
            if ($(input).attr('id')=="subs-save" || $(input).attr('id')=="subs-save-2") {
              $('.active-box-block .sub-selling-plan').first().removeAttr('disabled');
              $('.active-box-block .sub-selling-plan').first().removeAttr('hidden');
            }
            else {
              $('.active-box-block .sub-selling-plan').first().attr('disabled','disabled');
              $('.active-box-block .sub-selling-plan').first().attr('hidden','hidden');
                
            }
            $(input).attr('checked','checked');
            $(input).prop('checked', true);
            var newid = $(input).attr('id');
            $('.active-box-block #'+newid+'-2').attr('checked');
            $('.active-box-block #'+newid+'-2').prop('checked', true);
            
          });
        });
        
        inputSelects.forEach((input) => {
          if (radioButtons !== null) {
            inputValues.push(input.firstElementChild.value);
          } else {
            inputValues.push(input.value);
          }
          optionValues.push(count); 
          productInfo.variants.forEach((variant) => {
            if (JSON.stringify(variant.options) == JSON.stringify(inputValues)) {
              $('.active-box-block .shopify-product-form').first().attr('id', "product_form_"+variant.id);
              
              var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id ;
              /*
              if (!$('body').hasClass('template-index')) {
                window.history.replaceState({path: newurl}, '', newurl);
              }
              */
            } 
          });
          input.addEventListener('change', (evt) => {
            var currentValue = evt.target.value.toString();
            var changedIndex = inputSelects.indexOf(evt.currentTarget);
            inputValues[changedIndex] = currentValue;
            
            productInfo.variants.forEach((variant) => {
              if (JSON.stringify(variant.options) == JSON.stringify(inputValues)) {
                variantSKU.innerText = variant.sku;
                // var price = $('[value='+variant.id+']').attr('price');
                // var subsPrice = $('.active-box-block [data-subs-variant='+variant.id+']').attr('data-subs-price');
                // console.log(subsPrice);
                // variantPrice.innerText = price;
                // variantSubsPrice.innerText = subsPrice;
                var varid = variant.id;
                $('.active-box-block .shopify-product-form').first().attr('id', "product_form_"+varid);
                $('.variant-selector').each(function(){
                  $(this).removeAttr('checked');
                });
                $('[value="'+variant.title+'"]').first().attr('checked','checked');
                $('.product-variants option').each(function(){
                  $(this).removeAttr('selected');
                });
                $('[value="'+variant.id+'"]').first().attr('selected','selected');
                
              var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + varid ;
              /*  
              window.history.replaceState({path: newurl}, '', newurl);
              */
                
            }
            });
          
            
          });
          
        count += 1;
        });
      });
    }
    
  }
  else {
     productJson = [...document.querySelectorAll('[id^=ProductJson-')];
  
     if (productJson.length > 0 ) {
      productJson.forEach((product) => {
        var variantSKU;
        var productInfo;
        var radioButtons;
        var variantPrice;
        var variantSubsPrice;
        variantSKU = document.querySelector('.active-box-block span.variant-sku');
        variantPrice = document.querySelector('.active-box-block .product-price');
        variantSubsPrice = document.querySelector('.active-box-block .product-price-recharge');
        
        productInfo = JSON.parse(product.innerHTML);
       
        radioButtons = document.querySelector('.active-box-block .single-option-radio');
        var inputSelects;
        var orderOption = [...document.querySelectorAll('.active-box-block .recharge-subs-options')];
        
        if (radioButtons !== null) {
          inputSelects = [...document.querySelectorAll('.active-box-block .single-option-radio')];
        } else {
          inputSelects = [...document.querySelectorAll('.active-box-block .single-option-selector__radio')];
        }
        var inputValues = [];
        var optionValues = [];
        let count = 0;
        orderOption.forEach((input) => {
         
          input.addEventListener('change', (evt) => {
            $('.recharge-subs-options').each(function() {
              $(this).removeAttr('checked');
              $(this).prop('checked', false);
              var newid = $(this).attr('id');
              $('.active-box-block #'+newid+'-2').removeAttr('checked');
              $('.active-box-block #'+newid+'-2').prop('checked', false);
            });
            if ($(input).attr('id')=="subs-save" || $(input).attr('id')=="subs-save-2") {
              $('.active-box-block .sub-selling-plan').first().removeAttr('disabled');
              $('.active-box-block .sub-selling-plan').first().removeAttr('hidden');
            }
            else {
              $('.active-box-block .sub-selling-plan').first().attr('disabled','disabled');
              $('.active-box-block .sub-selling-plan').first().attr('hidden','hidden');
                
            }
            $(input).attr('checked','checked');
            $(input).prop('checked', true);
            var newid = $(input).attr('id');
              $('.active-box-block #'+newid+'-2').attr('checked','checked');
              $('.active-box-block #'+newid+'-2').prop('checked', true);
          });
        });
        
        inputSelects.forEach((input) => {
          if (radioButtons !== null) {
            inputValues.push(input.firstElementChild.value);
          } else {
            inputValues.push(input.value);
          }
          optionValues.push(count); 
          productInfo.variants.forEach((variant) => {
            if (JSON.stringify(variant.options) == JSON.stringify(inputValues)) {
              $('.active-box-block .shopify-product-form').first().attr('id', "product_form_"+variant.id);
              
              var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id ;
              /*
              window.history.replaceState({path: newurl}, '', newurl);
              */
            } 
          });
          input.addEventListener('change', (evt) => {
            var currentValue = evt.target.value.toString();
            var changedIndex = inputSelects.indexOf(evt.currentTarget);
            inputValues[changedIndex] = currentValue;
            
            productInfo.variants.forEach((variant) => {
              if (JSON.stringify(variant.options) == JSON.stringify(inputValues)) {
                variantSKU.innerText = variant.sku;
                var price = $('[value='+variant.id+']').attr('price');
                
                
                var varid = variant.id;
               
                $('.active-box-block .shopify-product-form').first().attr('id', "product_form_"+varid);
                $('.variant-selector').each(function(){
                  $(this).removeAttr('checked');
                });
                $('[value="'+variant.title+'"]').first().attr('checked','checked');
                $('.product-variants option').each(function(){
                  $(this).removeAttr('selected');
                });
                $('[value="'+variant.id+'"]').first().attr('selected','selected');
                
              var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + varid ;
              /*
              window.history.replaceState({path: newurl}, '', newurl);
              */
                
            }
            });
          
            
          });
          
        count += 1;
        });
      });
    }
  }
});

$(document).on('click', '.pdp-buy-box-varieties-container[page="subscription"] .pdp-buy-box-variety', function () {
  var variant_id = $(this).attr('data-id');
    var handle = $(this).attr('data-handle');
    var img = $(this).attr('data-feat-img');
    var prod_name = $(this).attr('data-title');
    var color = $(this).attr('data-color');
    var prod_descr = $(this).attr('data-descr');
    var prod_descr_full = $(this).attr('data-descr-full');
    var id = $(this).attr('data-id');
    var price = $(this).attr('price');
    
     
    $('.lsg-reviews.active').each(function() {
      $(this).removeClass('active');
    });
    
    $('.lsg-reviews-'+id).each(function() {
      $(this).addClass('active');
    });
   

    $('.active-box-block').each(function(){
        $(this).addClass('inactive-box-block');
        $(this).removeClass('active-box-block');
    });

    $('.pdp-buy-box-variety').each(function(){
      $(this).removeClass('active');
    });


    $('#'+id).addClass('active-box-block');
    $('#'+id).removeClass('inactive-box-block');

    $(this).addClass('active');

  

    $('#product-price-'+variant_id).text(price);
    
    // Update Product Title
    $('#lsg-product-name h1').replaceWith('<h1>'+prod_name+'</h1>');
    $('#lsg-product-name h1').css('color',color);
    $('#lsg-reviews svg path').css('fill',color);
    $('#lsg-description').empty();
    $('#lsg-description').append('<p>'+prod_descr+'</p>');

    // Update Hidden Input Variant ID
    $('.active-box-block .shopify-product-form').first().attr('id', "product_form_"+variant_id);

    $('.item .left .banner').attr('src', img);

    // Update Variant Buybox
    
    // Update Variant Selector
 
    $('.pdp-buy-box-varieties-header[data-handle="' + handle + '"]').addClass('current');

  productJson = [...document.querySelectorAll('.active-box-block .ProductJson')];
    
    if (productJson.length > 0 ) {
      productJson.forEach((product) => {
        var variantSKU;
        var productInfo;
        var radioButtons;
        if ($('body').hasClass('template-index')){
          variantSubsPrice = document.querySelector('.active-box-block .product-price-recharge');
        }
        variantSKU = document.querySelector('.active-box-block span.variant-sku');
        variantPrice = document.querySelector('.active-box-block .product-price');
        
        productInfo = JSON.parse(product.innerHTML);
       
        radioButtons = document.querySelector('.active-box-block .single-option-radio');
        var inputSelects;
        var orderOption = [...document.querySelectorAll('.active-box-block .recharge-subs-options')];
        if (radioButtons !== null) {
          inputSelects = [...document.querySelectorAll('.active-box-block .single-option-radio')];
        } else {
          inputSelects = [...document.querySelectorAll('.active-box-block .single-option-selector__radio')];
        }
        var inputValues = [];
        var optionValues = [];
        let count = 0;
        if ($('body').hasClass('template-index')){
          $('.recharge-subs-options').each(function() {
            $(this).removeAttr('checked');
            $(this).prop('checked', false);
          });
          $('.sub-selling-plan').each(function() {
            $(this).attr('disabled','disabled');
            $(this).attr('hidden','hidden');
          });  
        }
        
        $('.active-box-block #one-time, .active-box-block #one-time-2').attr('checked','checked');
        $('.active-box-block #one-time, .active-box-block #one-time-2').prop('checked','true');
        orderOption.forEach((input) => {
         
          input.addEventListener('change', (evt) => {
            
            $('.recharge-subs-options').each(function() {
              $(this).removeAttr('checked');
              $(this).prop('checked', false);
              var newid = $(this).attr('id');
              $('.active-box-block #'+newid+'-2').removeAttr('checked');
              $('.active-box-block #'+newid+'-2').prop('checked', false);
            });
            if ($(input).attr('id')=="subs-save" || $(input).attr('id')=="subs-save-2") {
              $('.active-box-block .sub-selling-plan').first().removeAttr('disabled');
              $('.active-box-block .sub-selling-plan').first().removeAttr('hidden');
            }
            else {
              $('.active-box-block .sub-selling-plan').first().attr('disabled','disabled');
              $('.active-box-block .sub-selling-plan').first().attr('hidden','hidden');
                
            }
            $(input).attr('checked','checked');
            $(input).prop('checked', true);
            var newid = $(input).attr('id');
              $('.active-box-block #'+newid+'-2').attr('checked','checked');
              $('.active-box-block #'+newid+'-2').prop('checked', true);
          });
        });
        inputSelects.forEach((input) => {
          if (radioButtons !== null) {
            inputValues.push(input.firstElementChild.value);
          } else {
            inputValues.push(input.value);
          }
          optionValues.push(count); 
          productInfo.variants.forEach((variant) => {
            if (JSON.stringify(variant.options) == JSON.stringify(inputValues)) {
              $('.active-box-block .shopify-product-form').first().attr('id', "product_form_"+variant.id);
              $('.variant-selector').each(function(){
                $(this).removeAttr('checked');
              });
              $('.product-variants option').each(function(){
                $(this).removeAttr('selected');
              });
              
              $('.active-box-block input[data-index=option0]').attr('checked','checked');
              $('.active-box-block .option1').attr('selected','selected');
              variantSKU.innerText = variant.sku; 
              // var price = $('[value='+variant.id+']').attr('price');
              // var subsPrice = $('.active-box-block [data-subs-variant='+variant.id+']').attr('data-subs-price');
              // console.log(subsPrice);
              // variantPrice.innerText = price;
              // variantSubsPrice.innerText = subsPrice;

              var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
              /*
              window.history.replaceState({path: newurl}, '', newurl);
              */
            } 
          });
          input.addEventListener('change', (evt) => {
            var currentValue = evt.target.value.toString();
            var changedIndex = inputSelects.indexOf(evt.currentTarget);
            inputValues[changedIndex] = currentValue;
            
            productInfo.variants.forEach((variant) => {
              if (JSON.stringify(variant.options) == JSON.stringify(inputValues)) {
                variantSKU.innerText = variant.sku; 
                // var price = $('[value='+variant.id+']').attr('price');
                // var subsPrice = $('.active-box-block [data-subs-variant='+variant.id+']').attr('data-subs-price');
                // console.log(subsPrice);
                // variantPrice.innerText = price;
                // variantSubsPrice.innerText = subsPrice;
                var varid = variant.id; 
                $('.active-box-block .shopify-product-form').first().attr('id', "product_form_"+varid);
                $('.variant-selector').each(function(){
                  $(this).removeAttr('checked');
                });
                $('[value="'+variant.title+'"]').first().attr('checked','checked');
                $('.product-variants option').each(function(){
                  $(this).removeAttr('selected');
                });
                $('[value="'+variant.id+'"]').first().attr('selected','selected');
                
              var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + varid ;
              
              /*
              window.history.replaceState({path: newurl}, '', newurl);
              */
                
            }
            });
          
            
          });
          
        count += 1;
        });
      });
    }
});
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

Colors.Currency = (function() {
  var moneyFormat = '$';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }
  return {
    formatMoney: formatMoney
  }
})();
Colors.Disclosure = (function() {
  var selectors = {
    disclosureList: '[data-disclosure-list]',
    disclosureToggle: '[data-disclosure-toggle]',
    disclosureInput: '[data-disclosure-input]',
    disclosureOptions: '[data-disclosure-option]'
  };

  var classes = {
    listVisible: 'disclosure-list--visible'
  };

  function Disclosure($disclosure) {
    this.$container = $disclosure;
    this.cache = {};
    this._cacheSelectors();
    this._connectOptions();
    this._connectToggle();
    this._onFocusOut();
  }

  Disclosure.prototype = _.assignIn({}, Disclosure.prototype, {
    _cacheSelectors: function() {
      this.cache = {
        $disclosureList: this.$container.find(selectors.disclosureList),
        $disclosureToggle: this.$container.find(selectors.disclosureToggle),
        $disclosureInput: this.$container.find(selectors.disclosureInput),
        $disclosureOptions: this.$container.find(selectors.disclosureOptions)
      };
    },

    _connectToggle: function() {
      this.cache.$disclosureToggle.on(
        'click',
        function(evt) {
          var ariaExpanded =
            $(evt.currentTarget).attr('aria-expanded') === 'true';
          $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);

          this.cache.$disclosureList.toggleClass(classes.listVisible);
        }.bind(this)
      );
    },

    _connectOptions: function() {
      this.cache.$disclosureOptions.on(
        'click',
        function(evt) {
          this._submitForm($(evt.currentTarget).data('value'));
        }.bind(this)
      );
    },

    _onFocusOut: function() {
      this.cache.$disclosureToggle.on(
        'focusout',
        function(evt) {
          var disclosureLostFocus =
            this.$container.has(evt.relatedTarget).length === 0;

          if (disclosureLostFocus) {
            this._hideList();
          }
        }.bind(this)
      );

      this.cache.$disclosureList.on(
        'focusout',
        function(evt) {
          var childInFocus =
            $(evt.currentTarget).has(evt.relatedTarget).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible
          );

          if (isVisible && !childInFocus) {
            this._hideList();
          }
        }.bind(this)
      );

      this.$container.on(
        'keyup',
        function(evt) {
          if (evt.which !== slate.utils.keyboardKeys.ESCAPE) return;
          this._hideList();
          this.cache.$disclosureToggle.focus();
        }.bind(this)
      );

      $('body').on(
        'click',
        function(evt) {
          var isOption = this.$container.has(evt.target).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible
          );

          if (isVisible && !isOption) {
            this._hideList();
          }
        }.bind(this)
      );
    },

    _submitForm: function(value) {
      this.cache.$disclosureInput.val(value);
      this.$container.parents('form').submit();
    },

    _hideList: function() {
      this.cache.$disclosureList.removeClass(classes.listVisible);
      this.cache.$disclosureToggle.attr('aria-expanded', false);
    },

    unload: function() {
      this.cache.$disclosureOptions.off();
      this.cache.$disclosureToggle.off();
      this.cache.$disclosureList.off();
      this.$container.off();
    }
  });

  return Disclosure;
})();
Colors.Shapes = (function() {

  function Shapes() {
    if(window.is_lt_ie9) return;
    this.render();
    $(document).on('shopify:section:load', this.render.bind(this));
  }

  Shapes.prototype = _.assignIn({}, Shapes.prototype, {
    
    render: function() {
      var self = this;
      $('.shape:not(.shaped)').each(function(index){
        var $this = $(this);
        if($this.hasClass('square')){
          $this
            .addClass('shaped')
            .find('br')
            .replaceWith(' ');
        }else if($this.hasClass('circle')){
          self.circlify($this, index);
        }else if ($this.hasClass('hexagon')){
          self.hexagonify($this, index);
        }
      });
    },

    circlify: function($element, index) {
      var $this = $element,
          $wrapper = $("<div class='shape-wrapper'>"),
          width = $this.width(),
          height = $this.height(),
          is_small = $this.hasClass('small'),
          default_min_side = is_small ? 30 : 60,
          min_side = $this.data('min-side') || default_min_side;
          padding = is_small ? 15 : 30,
          side = Math.max(Math.max(width, height) + padding, min_side);

      $wrapper
        .css('width', side);

      $this
        .css('border-radius', '50%')
        .css('vertical-align', 'middle')
        .css('width', side)
        .css('height', side)
        .html($('<span>')
          .html($this.html())
        )
        .addClass('shaped')
        .wrap($wrapper);
      },

      hexagonify: function($element, index) {
        // from http://csshexagon.com/

        if(window.is_lt_ie9){
          return;
        }

        if(!window.sheet){
          var style = document.createElement("style");
          style.setAttribute("type", "text/css");
          if (style.styleSheet) { // for IE
            style.styleSheet.cssText = "";
          } else { // others
            style.appendChild(document.createTextNode(""));
          }
          var h = document.getElementsByTagName('head')[0];
          h.appendChild(style);
          window.sheet = style.sheet;
        }

        var $this = $element,
            $wrapper = $("<div class='shape-wrapper'>"),
            is_small = $this.hasClass('small'),
            hexagonClass = "hexagon-" + index,
            root2 = 1.41421356237,
            root3 = 1.73205080757,
            scaleFactor = 0.577350269189626,
            width = $this.width(),
            height = $this.height();

        if(width > height){
          width = width + (is_small ? 15 : 30);
          height = width/root3;
        } else {
          width = height * root3;
        }

        var borderWidth = 3,
            borderColor = '#333',
            capWidth = width/root2,
            border = 'solid ' + borderWidth + 'px ' + borderColor,
            capBorder = 'solid ' + (borderWidth * root2) + 'px ' + borderColor,
            top = -width/root2/2,
            bottom = top,
            left = (width - capWidth)/2;

        if($this.hasClass('border')){
          left = left - borderWidth/2;
        }

        $this
          .addClass(hexagonClass)
          .html($('<span>')
            .html($this.html())
          );

        this.addCSSRule(
          window.sheet,
          '.' + hexagonClass,
          'width: ' + width + 'px;' +
          'height: ' + height + 'px;' +
          'margin-top: ' + height/2 + 'px;' +
          'margin-bottom: ' + height/2 + 'px;' +
          'border-left: ' + border + ';' +
          'border-right: ' + border + ';'
        );

        this.addCSSRule(
          window.sheet,
          '.' + hexagonClass + ':before',
          'width: ' + capWidth + 'px;' +
          'height: ' + capWidth + 'px;' +
          '-webkit-transform: scaleY(' + scaleFactor + ') rotate(-45deg);' +
          '-ms-transform: scaleY(' + scaleFactor + ') rotate(-45deg);' +
          'transform: scaleY(' + scaleFactor + ') rotate(-45deg);' + 
          'left: ' + left + 'px;' +
          'top: ' + top + 'px;' +
          'border-top: ' + capBorder + ';' +
          'border-right: ' + capBorder + ';'
        );

        this.addCSSRule(
          window.sheet, 
          '.' + hexagonClass + ':after', 
          'width: ' + capWidth + 'px;' +
          'height: ' + capWidth + 'px;' +
          '-webkit-transform: scaleY(' + scaleFactor + ') rotate(-45deg);' +
          '-ms-transform: scaleY(' + scaleFactor + ') rotate(-45deg);' +
          'transform: scaleY(' + scaleFactor + ') rotate(-45deg);' + 
          'left: ' + left + 'px;' +
          'bottom: ' + bottom + 'px;' +
          'border-bottom: ' + capBorder + ';' +
          'border-left: ' + capBorder + ';'
        );

        $this.wrap($wrapper);
        $this.addClass('shaped');
      },

      addCSSRule: function(sheet, selector, rules) {
        if("insertRule" in sheet) {
          sheet.insertRule(selector + "{" + rules + "}", 0);
        }
        else if("addRule" in sheet) {
          sheet.addRule(selector, rules);
        }
      }

  });

  return Shapes;
})();
Colors.Header = (function() {

  function Header(container) {
    var $header = $(container),
        $window = $(window),
        $bar = $('.bar', $header).clone().addClass('fixed').appendTo($header),
        is_home_page = $('body').hasClass('template-index'),
        are_featured_products_on_top = $('.home .sections .shopify-section').first().hasClass('section-featured-products'),
        to_solid_edge = are_featured_products_on_top ? $('.featured-products').offset().top + $('.featured-products').outerHeight() - $header.outerHeight() : false,
        not_interactive = !$header.hasClass('sticky') || $('body').hasClass('template-customers-login') || $('body').hasClass('template-customers-account') || $('body').hasClass('template-customers-addresses') || $('body').hasClass('template-customers-register') || $('body').hasClass('template-customers-login') || $('body').hasClass('template-404') || $('body').hasClass('template-cart') || $('body').hasClass('template-article'),
        interactive = !not_interactive,
        sticky_on_mobile = $header.hasClass('sticky-on-mobile'),
        self = this;

    $('.bar.fixed .currency-picker', $header).remove();
    // Keep submenu ids unique in the sticky copy of the bar
    $('[id^="MainNav-"]', $bar).attr('id', function(i, id){ return id + '-sticky'; });
    $('[aria-controls^="MainNav-"]', $bar).attr('aria-controls', function(i, id){ return id + '-sticky'; });

    if(interactive && !window.is_lt_ie9){

      var listen = function() {
        $window
          .on('scroll.header touchmove.header', function(e){
            var scroll_top = $window.scrollTop(),
                offset = $('.top-banner').outerHeight() || 0;
            $header.toggleClass('scrolled', scroll_top > offset);
            if(is_home_page && are_featured_products_on_top){
              $header.toggleClass('scrolling', scroll_top > offset + 30);
              $header.toggleClass('solid', scroll_top > to_solid_edge);
            } else {
              $header.toggleClass('solid', scroll_top > offset + 50);
            }
          })
          .trigger('scroll.header');
      }, forget = function() {
        $window.off('scroll.header touchmove.header');
        $header.removeClass('scrolled scrolling solid');
      }

      if(sticky_on_mobile) {
        listen();
      } else {
        enquire.register("screen and (min-width:620px)", {
          match : function() {
            listen();
          },
          unmatch : function() {
            forget();
          }
        });
      }
    }

    $(document)
      .on('opening', function(){
        self.fix();
      })
      .on('closing', function(){
        setTimeout(function(){
          self.free();
        }, 600);
      });
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    
    fix: function() {
      var $bar = $('.header.scrolled .bar.fixed');
      if ($bar.length){
        $bar
          .css('top', $bar.offset().top)
          .css('position', 'absolute');
      }
    },

    free: function() {
      var $bar = $('.header.scrolled .bar.fixed');
      if ($bar.length){
        $bar
          .css('top', 0)
          .css('position', 'fixed');
      }
    },

    onSelect: function(event) {
      if($('.side-nav').length == 0) {
        $('body.browsing .main').first().click();
      }
    }
  });

  return Header;
})();

Colors.Footer = (function() {

  function Footer(container) {
    this.$container = $(container);
    this.cache = {};
    this.cacheSelectors();

    if (this.cache.$localeDisclosure.length) {
      this.localeDisclosure = new Colors.Disclosure(
        this.cache.$localeDisclosure
      );
    }

    if (this.cache.$currencyDisclosure.length) {
      this.currencyDisclosure = new Colors.Disclosure(
        this.cache.$currencyDisclosure
      );
    }

    this.emailLinker();
    this.affiliateLinker();
  }

  Footer.prototype = _.assignIn({}, Footer.prototype, {
    cacheSelectors: function() {
      this.cache = {
        $localeDisclosure: this.$container.find('[data-disclosure-locale]'),
        $currencyDisclosure: this.$container.find('[data-disclosure-currency]'),
        $rte: this.$container.find('.contact p')
      };
    },

    emailLinker: function() {
      var regEx = /(\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*)(?![^<]*>|[^<>]*<\/)/g;
      if(this.cache.$rte.length){
        this.cache.$rte.each(function(){
          var $text = $(this);
          $text.html($text.html().replace(regEx, "<a href=\"mailto:$1\">$1</a>"));
        });
      }
    },

    affiliateLinker: function() {
      $('.footer [href="https://www.shopify.com"]').attr('href', "https://www.shopify.com?ref=guille-lopez");
    },

    onUnload: function() {
      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure.unload();
      }

      if (this.cache.$currencyDisclosure.length) {
        this.currencyDisclosure.unload();
      }
    }
  });

  return Footer;
})();
// Youtube API callback
function onYouTubeIframeAPIReady() {
  Colors.ProductVideo.loadVideos(Colors.ProductVideo.hosts.youtube);
}

Colors.ProductVideo = (function() {
  var videos = {};

  var hosts = {
    html5: 'html5',
    youtube: 'youtube'
  };

  var selectors = {
    productMediaWrapper: '[data-product-single-media-wrapper]'
  };

  var attributes = {
    enableVideoLooping: 'enable-video-looping',
    videoId: 'video-id'
  };

  function init(videoContainer, sectionId) {
    if (!videoContainer.length) {
      return;
    }

    var videoElement = videoContainer.find('iframe, video')[0];
    var mediaId = videoContainer.data('mediaId');

    if (!videoElement) {
      return;
    }

    videos[mediaId] = {
      mediaId: mediaId,
      sectionId: sectionId,
      host: hostFromVideoElement(videoElement),
      container: videoContainer,
      element: videoElement,
      ready: function() {
        createPlayer(this);
      }
    };

    var video = videos[mediaId];

    switch (video.host) {
      case hosts.html5:
        window.Shopify.loadFeatures([
          {
            name: 'video-ui',
            version: '1.0',
            onLoad: setupPlyrVideos
          }
        ]);
        Colors.LibraryLoader.load('plyrShopifyStyles');
        break;
      case hosts.youtube:
        Colors.LibraryLoader.load('youtubeSdk');
        break;
    }
  }

  function setupPlyrVideos(errors) {
    if (errors) {
      fallbackToNativeVideo();
      return;
    }

    loadVideos(hosts.html5);
  }

  function createPlayer(video) {
    if (video.player) {
      return;
    }

    var productMediaWrapper = video.container.closest(
      selectors.productMediaWrapper
    );
    var enableLooping = productMediaWrapper.data(attributes.enableVideoLooping);

    switch (video.host) {
      case hosts.html5:
        video.player = new Shopify.Plyr(video.element, {
          loop: { active: enableLooping }
        });
        break;
      case hosts.youtube:
        var videoId = productMediaWrapper.data(attributes.videoId);

        video.player = new YT.Player(video.element, {
          videoId: videoId,
          events: {
            onStateChange: function(event) {
              if (event.data === 0 && enableLooping) event.target.seekTo(0);
            }
          }
        });
        break;
    }

    productMediaWrapper.on('mediaHidden xrLaunch', function() {
      if (!video.player) return;

      if (video.host === hosts.html5) {
        video.player.pause();
      }
      if (video.host === hosts.youtube && video.player.pauseVideo) {
        video.player.pauseVideo();
      }
    });

    productMediaWrapper.on('mediaVisible', function() {
      if (Colors.Helpers.isTouch()) return;
      if (!video.player) return;

      if (video.host === hosts.html5) {
        video.player.play();
      }
      if (video.host === hosts.youtube && video.player.playVideo) {
        video.player.playVideo();
      }
    });
  }

  function hostFromVideoElement(video) {
    if (video.tagName === 'VIDEO') {
      return hosts.html5;
    }
    if (video.tagName === 'IFRAME') {
      if (
        /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
          video.src
        )
      ) {
        return hosts.youtube;
      }
    }
    return null;
  }

  function loadVideos(host) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        if (video.host === host) {
          video.ready();
        }
      }
    }
  }

  function fallbackToNativeVideo() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];

        if (video.nativeVideo) continue;

        if (video.host === hosts.html5) {
          video.element.setAttribute('controls', 'controls');
          video.nativeVideo = true;
        }
      }
    }
  }

  function removeSectionVideos(sectionId) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        if (video.sectionId === sectionId) {
          if (video.player) video.player.destroy();
          delete videos[key];
        }
      }
    }
  }

  return {
    init: init,
    hosts: hosts,
    loadVideos: loadVideos,
    removeSectionVideos: removeSectionVideos
  };
})();
Colors.ProductModel = (function() {
  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};

  var selectors = {
    mediaGroup: '[data-product-single-media-group]',
    xrButton: '[data-shopify-xr]'
  };

  function init(modelViewerContainers, sectionId) {
    if (Shopify.designMode) {
      window.Shopify.detectLoadJS();
    }

    modelJsonSections[sectionId] = {
      loaded: false
    };

    modelViewerContainers.each(function(index) {
      var $modelViewerContainer = $(this);
      var mediaId = $modelViewerContainer.data('media-id');
      var $modelViewerElement = $(
        $modelViewerContainer.find('model-viewer')[0]
      );
      var modelId = $modelViewerElement.data('model-id');

      if (index === 0) {
        var $xrButton = $modelViewerContainer
          .closest(selectors.mediaGroup)
          .find(selectors.xrButton);
        xrButtons[sectionId] = {
          $element: $xrButton,
          defaultId: modelId
        };
      }

      models[mediaId] = {
        modelId: modelId,
        sectionId: sectionId,
        $container: $modelViewerContainer,
        $element: $modelViewerElement
      };
    });

    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: setupShopifyXr
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: setupModelViewerUi
      }
    ]);

    Colors.LibraryLoader.load('modelViewerUiStyles');
  }

  function setupShopifyXr(errors) {
    if (errors) {
      return;
    }
    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', function() {
        setupShopifyXr();
      });
      return;
    }

    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId];

        if (modelSection.loaded) continue;
        var $modelJson = $('#ModelJson-' + sectionId);

        window.ShopifyXR.addModels(JSON.parse($modelJson.html()));
        modelSection.loaded = true;
      }
    }
    window.ShopifyXR.setupXRElements();
  }

  function setupModelViewerUi(errors) {
    if (errors) {
      return;
    }
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.$element);
        }
        setupModelViewerListeners(model);
      }
    }
  }

  function setupModelViewerListeners(model) {
    var xrButton = xrButtons[model.sectionId];
    model.$container.on('mediaVisible', function() {
      xrButton.$element.attr('data-shopify-model3d-id', model.modelId);
      if (Colors.Helpers.isTouch()) return;
      model.modelViewerUi.play();
    });
    model.$container
      .on('mediaHidden', function() {
        xrButton.$element.attr('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      })
      .on('xrLaunch', function() {
        model.modelViewerUi.pause();
      });
  }

  function removeSectionModels(sectionId) {
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (model.sectionId === sectionId) {
          delete models[key];
        }
      }
    }
    delete modelJsonSections[sectionId];
  }

  return {
    init: init,
    removeSectionModels: removeSectionModels
  };
})();
Colors.Product = (function() {

  function Product(container) {
    this.$container = $(container);

    this.initVariants();
    this.initImageZoom();
    this.initMediaGallery();
    this.initProductVideo();
    this.initProductModel();
    this.initShopifyXrLaunch();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    initVariants: function() {
      var sectionId = this.$container.attr('data-section-id');
      var productId = $('.active-box-block').first().attr('data-product-id');
      if( $('#LSG-Buy-Box').length){
        this.selectors = {
          originalSelectorId: '#productSelect-' + productId,
          unitPrice: '.active-box-block #unitPrice-' + sectionId,
          productQuantity: '#productQuantity-' + productId,
          singleOptionSelector: '.single-option-selector-' + productId
        };
      }
      else{
      this.selectors = {
        originalSelectorId: '#productSelect-' + sectionId,
        addToCart: '#addToCart-' + sectionId,
        productPrice: '#productPrice-' + sectionId,
        comparePrice: '#comparePrice-' + sectionId,
        unitPrice: '#unitPrice-' + sectionId,
        productQuantity: '#productQuantity-' + sectionId,
        singleOptionSelector: '.single-option-selector-' + sectionId
      };
    }
      this.settings = {
        sectionId: sectionId,
        enableHistoryState: this.$container.data('enable-history-state') || true,
        namespace: '.product-' + sectionId
      };

      // Stop parsing if we don't have the product json script tag
      if (!$('#ProductJson-' + sectionId).html()) {
        return;
      }

      this.productSingleObject = JSON.parse($('#ProductJson-' + sectionId).html());

      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        product: this.productSingleObject,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId
      };

      if ($(options.originalSelectorId).length) {
        this.variants = new Colors.Variants(options);
        this.$container.on('variantChange' + this.settings.namespace, this.updateAddToCartButton.bind(this));
        this.$container.on('variantPriceChange' + this.settings.namespace, this.updatePrices.bind(this));
        this.$container.on('variantImageChange' + this.settings.namespace, this.updateMedia.bind(this));
      }
    },

    updateAddToCartButton: function(event) {
      var variant = event.variant;

      var cache = {
        $quantity: $(this.selectors.productQuantity)
      };

      if (variant) {
        // Select a valid variant if available
        if (variant.available) {
          // We have a valid product variant, so enable the submit button
          this.enableAddToCart();
        } else {
          // Variant is sold out, disable the submit button
          this.disableAddToCart();
        }

        // Update quantity selector
        if (cache.$quantity.length) {
          variant.inventory_quantity = window.product.inventory[variant.id];
          if (variant.inventory_management == 'shopify' && variant.inventory_quantity > 0) {
            cache.$quantity.empty();
            for(var i=1; i<=Math.min(variant.inventory_quantity, 50); i++) {
              cache.$quantity.append($("<option></option>").attr("value", i).text(i));
            }
          } else {
            cache.$quantity.empty();
            for(var i=1; i<=50; i++) {
              cache.$quantity.append($("<option></option>").attr("value", i).text(i));
            }
          }
        }

      } else {
        this.disableAddToCart();
      }
    },

    updatePrices: function(event) {
      var variant = event.variant;

      if (variant) {
        $(this.selectors.productPrice).html($('<span>').html(Colors.Currency.formatMoney(variant.price, Colors.strings.money_format)));

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          $(this.selectors.comparePrice).html($('<span>').html(Colors.Currency.formatMoney(variant.compare_at_price, Colors.strings.money_format))).show();
          $(this.selectors.productPrice).addClass('on-sale');
        } else {
          $(this.selectors.comparePrice).hide();
          $(this.selectors.productPrice).removeClass('on-sale');
        }

        // And the unit price
        if (variant.unit_price_measurement) {
          unitPrice = Colors.Currency.formatMoney(variant.unit_price, Colors.strings.money_format);
          unitPrice += ' / ';
          unitPrice += this._getBaseUnit(variant);
          $(this.selectors.unitPrice).html($('<span>').addClass('unit-price').html(unitPrice)).show();
        } else {
          $(this.selectors.unitPrice).empty().hide();
        }

      } else {
        $(this.selectors.comparePrice).hide();
        $(this.selectors.unitPrice).empty().hide();
      }
    },

    _getBaseUnit: function(variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    },

    updateMedia: function(event) {
      var variant = event.variant;

      if (variant) {
        if (variant.featured_image) {
          var id = variant.featured_media.id,
              $newMedia = $('#' + id);

          if($newMedia.length){
            $newMedia.siblings().addClass('hide').trigger('mediaHidden');
            $newMedia.removeClass('hide').trigger('mediaVisible');
          }
        }
      }
    },

    enableAddToCart: function(){
      var $addToCart = $(this.selectors.addToCart);
      if($addToCart.prop('disabled') === true){
        $addToCart
          .prop('disabled', false)
          .html(Colors.strings.add_to_cart);
      }
    },

    disableAddToCart: function(copy){
      var $addToCart = $(this.selectors.addToCart);
      if($addToCart.prop('disabled') === false){
        $addToCart
          .prop('disabled', true)
          .html(Colors.strings.unavailable);
      }
    },

    initMediaGallery: function() {
      var self = this;
      $(document)
        .on('touchstart click', '[data-action=show-product-media][data-id]', function(e){
          if(e.type == "click") e.preventDefault();
          if(is_touch_device && e.type == "click") return;
          if(!is_touch_device && e.type == "touchstart") return;

          var $newMedia = $('#' + $(this).data('id'));
          $newMedia.siblings().addClass('hide').trigger('mediaHidden');
          $newMedia.removeClass('hide').trigger('mediaVisible');
        });
    },

    initImageZoom: function() {
      $('[data-mfp-src]', this.$container).magnificPopup({
        type: 'image',
        mainClass: 'mfp-fade',
        closeOnBgClick: true,
        closeBtnInside: false,
        closeOnContentClick: true,
        tClose: 'Close (Esc)',
        removalDelay: 500,
        closeMarkup: '<button title="%title%" class="mfp-close"><i class="fc fc-close"></i></button>',
        gallery: {
          enabled:true,
          navigateByImgClick: false,
          arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
          tPrev: 'Previous (Left arrow key)',
          tNext: 'Next (Right arrow key)'
        }
      });
    },

    initProductVideo: function() {
      var sectionId = this.settings.sectionId;
      $('[data-product-media-type-video]', this.$container).each(function() {
        Colors.ProductVideo.init($(this), sectionId);
      });
    },

    initProductModel: function() {
      var $modelViewerElements = $(
        '[data-product-media-type-model]',
        this.$container
      );
      if ($modelViewerElements.length < 1) return;
      Colors.ProductModel.init($modelViewerElements, this.settings.sectionId);
    },

    initShopifyXrLaunch: function() {
      var self = this;
      $(document).on('shopify_xr_launch', function() {
        var $currentMedia = $(
          self.selectors.productMediaWrapper +
            ':not(.' +
            self.classes.hidden +
            ')',
          self.$container
        );
        $currentMedia.trigger('xrLaunch');
      });
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
      Colors.ProductVideo.removeSectionVideos(this.settings.sectionId);
      Colors.ProductModel.removeSectionModels(this.settings.sectionId);
    }
  });

  return Product;
})();
Colors.RelatedProducts = (function() {

  function RelatedProducts(container) {
    var self = this;

    self.$container = $(container);
    self.$product_related_products = $('.product-related-products[data-product-id]', this.$container);

    if (self.$product_related_products.length) {
      var productId = this.$product_related_products.data('product-id'),
          limit = this.$product_related_products.data('limit') || 4,
          baseUrl = this.$product_related_products.data('base-url'),
          url = baseUrl + "?section_id=related-products-template&limit="+limit+"&product_id="+productId;

      $.ajax({
        type: 'GET',
        dataType: 'html',
        url: url,
        success: function(data) {
          var $data = $(data),
              $new_product_related_products = $data.find('.product-related-products')
              $dom_product_related_products = $('.product-related-products', self.$container);
          $dom_product_related_products.replaceWith($new_product_related_products);
        }
      });
    }
  }

  return RelatedProducts;
})();

Colors.Collection = (function() {

  function Collection(container) {
    this.$container = $(container);
    this.init();
  }

  Collection.prototype = _.assignIn({}, Collection.prototype, {
    init: function() {
      this.initNavigation();
      this.initInteractions();
    },

    initNavigation: function() {
      this.initProductCategories();
      this.initProductPagination();
    },

    initProductCategories: function() {
      var $categories = $('.categories', this.$container),
          $body = $('body'),
          section_id = this.$container.attr('data-section-id'),
          collection_id = $('[data-collection-id]', this.$container).data('collection-id'),
          cache = 'section-' + section_id + '-' + collection_id + '-categories',
          active_section_id_cache = cache + 'active-section-id';

      if($categories.length == 1){
        if ($body.data(cache)) {
          $cached_categories = $body.data(cache).clone(true, true);
          $categories.replaceWith($cached_categories);
          if ($body.data(active_section_id_cache)) {
            $('.active', $cached_categories).removeClass('active');
            $('#' + $body.data(active_section_id_cache), $cached_categories).addClass('active');
          }
          $('.active', $cached_categories).trigger('click');
        } else {
          var loadNextTag = function(){
            var $tags = $('a:not(.loaded)', $categories);

            if ($tags.length > 0){
              var $tag = $tags.first(),
                  url = $tag.attr('href');

              $.ajax({
                type: 'GET',
                dataType: 'html',
                url: url,
                success: function(data) {
                  var $data = $(data),
                      $collection_products = $data.find('.collection-products'),
                      title = $data.filter('title').text()
                      count = 0;

                  if($collection_products.length){
                    count = $collection_products.data('count');
                    $('sup', $tag).text(count);
                  }

                  if(count == 0){
                    $tag.parent('li').remove();
                  } else {
                    if(window.is_touch_device || window.is_lt_ie9){
                      $collection_products.removeClass('with-interactions');
                    }

                    $tag
                      .addClass('loaded')
                      .data('collection-products', $collection_products)
                      .on('touchstart click', function(e){
                        if(!e.ctrlKey && !e.metaKey){
                          if(e.type == "click") e.preventDefault();
                          if(is_touch_device && e.type == "click") return;
                          if(!is_touch_device && e.type == "touchstart") return;

                          var $tag = $(this),
                              $container = $(this).parents('.collection'),
                              $categories = $('.categories', $container),
                              $dom_collection_products = $('.collection-products', $container);

                          $dom_collection_products.html($tag.data('collection-products').html())
                          $('a', $categories).removeClass('active');
                          $tag.addClass('active');
                          Colors.initShapes();
                          $dom_collection_products.fadeTo(0,0).fadeTo(300, 1);
                          if (!$('body').hasClass('template-index')) {
                            if (e.originalEvent) {
                              document.title = title;
                              window.history.pushState({url: url}, title, url);
                            }
                          }
                          $body.data(active_section_id_cache, $tag.attr('id'));
                        }
                      });
                  }

                  loadNextTag();
                }
              });
            } else {
              $body.data(cache, $categories.clone(true, true));
            }
          };
          loadNextTag();
        }
      }
    },

    initProductPagination: function() {
      // just in the home page
      if($('body').hasClass('template-index')) {
        var collection_url = $('[data-collection-url]', this.$container).data('collection-url'),
            self = this;

        $('.pagination a', this.$container).each(function(){
          var url = $(this).attr('href');
          if(url.indexOf('/?page=') === 0){
            $(this).attr('href', collection_url + url);
          }
        });

        this.$container.on('click.pagination', '.pagination a', function(e){
          var url = $(this).attr('href');
          if(!e.ctrlKey && !e.metaKey){
            $.ajax({
              type: 'GET',
              dataType: 'html',
              url: url,
              success: function(data) {
                var $data = $(data),
                    $collection_products = $data.find('.collection-products'),
                    $dom_collection_products = $('.collection-products', self.$container),
                    title = $data.filter('title').text()
                    count = 0,
                    offset = 0,
                    duration = 0;

                $dom_collection_products.replaceWith($collection_products);
                Colors.initShapes();

                if(window.is_touch_device || window.is_lt_ie9){
                  $collection_products.removeClass('with-interactions');
                }

                $dom_collection_products.fadeTo(0,0).fadeTo(300, 1);
                if ($('body').hasClass('template-index')) {
                  offset = self.$container.offset().top - $('.header').outerHeight();
                  duration = 600;
                }
                $('body,html').animate({ scrollTop: offset}, { duration: duration });
                if (e.originalEvent) {
                  // document.title = title;
                  // window.history.pushState({url: url}, title, url);
                }
              }
            });
            e.preventDefault();
          }
        });
      }
    },

    initInteractions: function() {
      var $collection = $('.collection-products', this.$container),
          self = this;

      if($collection.length == 1){
        if(window.is_touch_device || window.is_lt_ie9 ){
          $collection.removeClass('with-interactions');
        }
        if($('.template-product:not(.dummie)').length == 0 && !window.is_lt_ie9){
            enquire.register("screen and (min-width:620px)", {
              match : function() {
                self.initProductPreviews();
              },      
              unmatch : function() {
                self.stopProductPreviews();
                self.closeProductPreviews();
              }
            });
        }
      }
    },

    initProductPreviews: function(){
      var self = this;
      this.$container
        .on('click.productPreview', '.collection-product[href]:not(.dummie)', function(e){
          var $this = $(this),
              $collection = $this.parents('.collection-products');

          if(!e.ctrlKey && !e.metaKey && $collection.hasClass('with-previews')){
            var $current = $this,
                $insertAfterProduct = false;

            if($this.hasClass('opened')){
              e.preventDefault();
              return;
            } 

            $this.addClass('opened');

            // find next product before 
            // a clear: left product.
            do{
              var $next = $current.next();
              if($next.length){
                if($next.css('clear') == 'left'){
                  $insertAfterProduct = $current;
                } else {
                  $current = $next;
                }
              } else {
                $insertAfterProduct = $current;
              }
            } while(!$insertAfterProduct);

            // Load preview
            $.ajax({
              type: 'GET',
              dataType: 'html',
              url: $this.attr('href'),
              success: function(data) {
                var $preview = $(data).find('.content.product'),
                    $page = $('body,html');

                // close previous previews
                $('.collection-product.opened', self.$container).not($this).removeClass('opened');
                $('.preview', self.$container).remove();

                // insert element
                $preview
                  .addClass('preview')
                  .insertAfter($insertAfterProduct)
                  .data('thumbnail', $this);

                // init product page
                new Colors.Product($preview);
                Shopify.PaymentButton && Shopify.PaymentButton.init();

                // remember previous scroll position
                window.previousScrollTop = $(window).scrollTop();

                // animate in
                $page
                  .one('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function(){
                    $page.stop();
                  })
                  .delay(250)
                  .animate({
                    scrollTop: Math.round($preview.offset().top - $('.header').outerHeight() - 30)
                  }, {
                    duration: 1200,
                    delay: 2000,
                    easing: "easeOutQuad",
                    done: function(){
                      $page.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
                    }
                  });
              }
            });
            e.preventDefault();
          }
        })
        .on('click.closePreview', '[data-action=close-preview]', function(e){
          var $preview = $(this).parents('.preview'),
              removeProduct = function(){
                $preview.slideUp({
                  duration: 600,
                  easing: "easeInOutQuad",
                  complete: function(){
                    var $this = $(this),
                        $thumbnail = $this.data('thumbnail');
                    $this.remove();
                    $thumbnail.removeClass('opened');
                  }
                });
              };

          if(window.previousScrollTop && $('.preview').length == 1){
            $('body,html').animate({
              scrollTop: window.previousScrollTop
            }, {
              duration: 600,
              easing: "easeInOutQuad",
              complete: function(){
                removeProduct();
              }
            });
          } else{
            removeProduct();
          }
          window.previousScrollTop = false;
          e.preventDefault();
        });
    },

    closeProductPreviews: function(){
      $('.product.preview', this.$container).remove();
    },

    stopProductPreviews: function(){
      this.$container.off('click.productPreview');
    },
    
    onUnload: function(event) {
      this.$container
        .off('click.closePreview')
        .off('click.productPreview')
        .off('click.pagination');

      $('.categories a', this.$container).each(function(){
        $(this)
          .off('click');
      });
    }
  });

  return Collection;
})();
Colors.Collections = (function() {

  function Collections(container) {
    var $container = $(container),
        $items = $('.collections-items', $container);
    if($items.length){
      if(window.is_touch_device){
        $items.removeClass('interactive');
      }
    }
  }

  return Collections;
})();

Colors.FeaturedProducts = (function() {
  var PRODUCT_HEIGHT = 630;

  function FeaturedProducts(container) {
    var $container = this.$container = $(container),
        $products = this.$products = $('.featured-product', $container),
        $window = $(window), $body = $('body'), $doc = $(document),
        self = this;

    if($products.length <= 1) return;
    if(!$container.hasClass('with-transition')) return;

    var onScroll = function(e){
      var header_height = $('.header .bar').outerHeight(true),
          scroll_top = $window.scrollTop() + header_height,
          container_offset_top = $container.offset().top,
          container_height = $container.outerHeight();
          container_scroll_top = scroll_top - container_offset_top,
          viewport_offset = - ($window.height() - header_height) / 2,
          last_product_height = PRODUCT_HEIGHT,
          $product = self.getActiveProduct(container_scroll_top, viewport_offset);

      if(scroll_top >= container_offset_top && scroll_top <= container_offset_top + container_height - last_product_height) {
        $container.addClass('active');
        $products.removeClass('active');
        $product.addClass('active');
      } else {
        $container.removeClass('active');
        $products.removeClass('active');
      }
    };

    $window
      .on('scroll.featured-products', onScroll)
      .trigger('scroll.featured-products');

    $doc
      .on('opening', function(){
        var $product = $container.find('.active.featured-product'),
            $info = $product.find('.info');
        if($product.length) {
          $info.css('top', $info.offset().top - $product.offset().top);
          $product.addClass('absolute');
        }
      })
      .on('closing', function(){
        setTimeout(function(){
          var $product = $container.find('.active.featured-product'),
              $info = $product.find('.info');
          if($product.length) {
            $product.removeClass('absolute');
            $info.css('top', 65);
          }
        }, 600);
      });

    enquire.register("screen and (max-width:620px)", {
      match : function() {
        $window.off('scroll.featured-products');
        $container.removeClass('active');
        $products.removeClass('active absolute');
      },
      unmatch : function() {
        $window
          .on('scroll.featured-products', onScroll)
          .trigger('scroll.featured-products');
      }
    });
  }

  FeaturedProducts.prototype = _.assignIn({}, FeaturedProducts.prototype, {
    getActiveProduct: function(container_scroll_top, viewport_offset){
      var height = viewport_offset;
      for(var i=0; i < this.$products.length; i++) {
        height += PRODUCT_HEIGHT;
        if (container_scroll_top <= height) {
          return this.$products.eq(i);
        }
      }
      return $('.doesnt-exist');
    },

    onBlockSelect: function(event) {
      $target = $(event.target);
      $('body,html').animate({ scrollTop: $target.offset().top - 30 }, { duration: 600 });
    },

    onUnload: function(event) {
      $(window)
        .off('scroll.featured-products');
      $(document)
        .off('opening')
        .off('closing');
    }
  });

  return FeaturedProducts;
})();

Colors.Map = (function() {

  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  function Map(container) {
    this.$container = $(container);
    var key = this.$container.data('api-key');

    if (typeof key !== 'string' || key === '') {
      return;
    }

    if (apiStatus === 'loaded') {
      var self = this;

      // Check if the script has previously been loaded with this key
      var $script = $('script[src*="' + key + '&"]');
      if ($script.length === 0) {
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + key
        ).then(function() {
          apiStatus = 'loaded';
          self.createMap();
        });
      } else {
        this.createMap();
      }
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          })
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-container');

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              styles: config.styles,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: center
            });

            google.maps.event.addDomListener(window, 'resize', function() {
              google.maps.event.trigger(map, 'resize');
              map.setCenter(center);
            });
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = Colors.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = Colors.strings.addressQueryLimit;
              break;
            default:
              errorMessage = Colors.strings.addressError;
              break;
          }

          // Only show error in the theme editor
          if (true) {
            $map
              .addClass('error')
              .find('.warning')
              .html(errorMessage);
          }
        });
    },

    onUnload: function() {
      if (typeof window.google !== 'undefined') {
        google.maps.event.clearListeners(this.map, 'resize');
      }
    }
  });

  return Map;
})();

Colors.Slideshow = (function() {
  var $slideshow;

  function Slideshow(container) {
    $slideshow = $(container);
    $slideshow
      .on('init', function(event, slick){
        var $ui = $('.slick-dots, .slick-prev, .slick-next', $slideshow);
        if($(slick.$slides.get(0)).hasClass('is-light')) {
          $ui.addClass('is-light');
        } else {
          $ui.removeClass('is-light');
        }
      })
      .on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var $ui = $('.slick-dots, .slick-prev, .slick-next', $slideshow);
        if($(slick.$slides.get(nextSlide)).hasClass('is-light')) {
          $ui.addClass('is-light');
        } else {
          $ui.removeClass('is-light');
        }
      })
      .slick({
        arrows: $slideshow.data('arrows'),
        dots: $slideshow.data('dots'),
        autoplay: $slideshow.data('autoplay'),
        autoplaySpeed: $slideshow.data('speed') * 1000,
        fade: $slideshow.data('use-fade'),
        speed: $slideshow.data('use-fade') ? 600 : 1200,
        accessibility: false
      });
  };

  Slideshow.prototype = _.assignIn({}, Slideshow.prototype, {

    onDeselect: function(event) {
      if ($slideshow.data('autoplay')) {
        $slideshow.slick('slickPlay');
      }
    },
    onBlockSelect: function(event) {
      $target = $(event.target);
      $slideshow.slick('slickPause');
      $slideshow.slick('slickGoTo', $target.data('index'), true);
    },
    onBlockDeselect: function(event) {
      this.onDeselect(event);
    },
    onUnload: function(event) {
      $slideshow
        .off('init')
        .off('beforeChange');
    }
  });

  return Slideshow;
})();
window.themeInfo = {name: "Colors"};

$(document).ready(function() {
  
  Colors.initIE();
  Colors.initiOS();
  Colors.initPlaceholders();
  Colors.initEasings();
  Colors.initSections();
  Colors.initLoginPage();
  Colors.initAddressesPage();
  Colors.initListeners();
  Colors.initNewsletter();
  Colors.onFontsLoaded();
});

Colors.initIE = function(){
  window.is_lt_ie9 = $("html").hasClass("lt-ie9");
  if (navigator.userAgent.indexOf("MSIE ") > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)){
    $("html").addClass("ie");
  }
};

Colors.initiOS = function(){
  if(window.is_ios && !window.MSStream){
    // fix for safari ios 9 viewport problem
    // https://forums.developer.apple.com/thread/13510
    document.querySelector('meta[name=viewport]').setAttribute(
      'content',
      'initial-scale=1.0001, minimum-scale=1.0001, maximum-scale=1.0001, user-scalable=no'
    );
  }
}

Colors.initPlaceholders = function(){
  $('input, textarea').placeholder();
};

Colors.initEasings = function(){
  var baseEasings = {};

  $.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function( i, name ) {
    baseEasings[ name ] = function( p ) {
      return Math.pow( p, i + 2 );
    };
  });

  $.extend( baseEasings, {
    Sine: function( p ) {
      return 1 - Math.cos( p * Math.PI / 2 );
    },
    Circ: function( p ) {
      return 1 - Math.sqrt( 1 - p * p );
    },
    Elastic: function( p ) {
      return p === 0 || p === 1 ? p :
        -Math.pow( 2, 8 * (p - 1) ) * Math.sin( ( (p - 1) * 80 - 7.5 ) * Math.PI / 15 );
    },
    Back: function( p ) {
      return p * p * ( 3 * p - 2 );
    },
    Bounce: function( p ) {
      var pow2,
        bounce = 4;

      while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
      return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
    }
  });

  $.each( baseEasings, function( name, easeIn ) {
    $.easing[ "easeIn" + name ] = easeIn;
    $.easing[ "easeOut" + name ] = function( p ) {
      return 1 - easeIn( 1 - p );
    };
    $.easing[ "easeInOut" + name ] = function( p ) {
      return p < 0.5 ?
        easeIn( p * 2 ) / 2 :
        1 - easeIn( p * -2 + 2 ) / 2;
    };
  });
};

Colors.initSections = function(){
  var sections = new Colors.Sections();

  sections.register('header', Colors.Header);
  sections.register('map', Colors.Map);
  sections.register('slideshow', Colors.Slideshow);
  sections.register('collection', Colors.Collection);
  sections.register('collections', Colors.Collections);
  sections.register('product', Colors.Product);
  sections.register('related-products', Colors.RelatedProducts);
  sections.register('featured-products', Colors.FeaturedProducts);
  sections.register('footer', Colors.Footer);
};

Colors.initLoginPage = function(){

  $(document)
    .on('click', '[data-action=toggle-recover-password]', function(){
      $('#recover_password').toggle();
      $('#login, #register, #guest').toggle();

      if($('#recover_password').is(':visible')){
        if(!$('#recover_password .btn').hasClass('round')){
          $('#recover_password .btn').addClass('round');
          Colors.initShapes();
        }
        $('#recover_password input#recover-email').focus();
      } else {
        if(!$('#login .btn, #register .btn, #guest .btn').hasClass('round')){
          $('#login .btn, #register .btn, #guest .btn').addClass('round');
          Colors.initShapes();
        }
        $('#login input#customer_email').focus();
      }
    });

  // direct access to recover page: account/login#recover
  if (window.location.hash == '#recover'){ 
    $('#login .round, #register .round, #guest .round').removeClass('round');
    $('[data-action=toggle-recover-password]').first().click();
  }
};

Colors.initAddressesPage = function(){
  var $body = $('body');

  if ($body.hasClass('template-customers-addresses') && window.customer_addresses){
    // Initialize observers on address selectors
    new Shopify.CountryProvinceSelector('address_country_new', 'address_province_new', {
      hideElement: 'address_province_container_new'
    });

    // Setup province selector on each customer address
    for(var i in window.customer_addresses){
      var id = window.customer_addresses[i];
      new Shopify.CountryProvinceSelector('address_country_' + id, 'address_province_' + id, {
        hideElement: 'address_province_container_' + id
      });
    }

    // Contents of customer_area.js (global asset)
    Shopify.CustomerAddress = {
      toggleForm: function(id) {
        var $form = $('#edit_address_' + id),
            $button = $('#view_address_' + id);
        
        $form.toggle();
        $button.toggle();

        if ($form.is(':visible')){
          $('input:not([type=hidden])', $form).first().focus()
          $('body,html').animate({ scrollTop: $form.offset().top}, { duration: 600 });
        }

        return false;
      },

      toggleNewForm: function() {
        var $form = $('#add_address'),
            $button = $('#add_new_address_button');

        $form.toggle();
        $button.toggle();

        if ($form.is(':visible')){
          $('input:not([type=hidden])', $form).first().focus()
          $('body,html').animate({ scrollTop: $form.offset().top}, { duration: 600 });
        }
        return false;
      },

      destroy: function(id, confirm_msg) {
        if (confirm(confirm_msg || "Are you sure you wish to delete this address?")) {
          Shopify.postLink('/account/addresses/'+id, {'parameters': {'_method': 'delete'}});
        }
      }
    }
  }
};

Colors.initListeners = function(){

  var $document = $(document),
      $body = $('body'),
      cartOpener = null;

  function openSideCart(){
    var $sideCart = $('.side-cart');
    if(!$body.hasClass('shopping')){
      // Remember what opened the cart so focus can go back there on close
      var active = document.activeElement;
      cartOpener = active && active !== document.body && $(active).closest('.side-cart').length === 0 ? active : null;
      $document.trigger('opening');
      $body.addClass('shopping');
    }
    $sideCart.attr('aria-hidden', 'false');
    var $firstFocusable = $sideCart.find('a, button, input, [tabindex]:not([tabindex="-1"])').first();
    if($firstFocusable.length){
      $firstFocusable.focus();
    } else {
      $sideCart.attr('tabindex', '-1').focus();
    }
  }

  function closeSideCart(){
    $document.trigger('closing');
    $body.removeClass('shopping');
    $('.side-cart').attr('aria-hidden', 'true');
    var $opener = cartOpener && $.contains(document, cartOpener) && $(cartOpener).is(':visible') ? $(cartOpener) : $('.header .icon-cart:visible').first();
    cartOpener = null;
    $opener.focus();
  }

  $document
    .on('touchstart click', '[data-action=toggle-browse]', function(e){
      if(e.type == "click") e.preventDefault();
      if(is_touch_device && e.type == "click") return;
      if(!is_touch_device && e.type == "touchstart") return;

      var browseOpening = !$body.hasClass('browsing');
      $document.trigger(browseOpening ? 'opening' : 'closing');
      $body.toggleClass('browsing');
      $('.header .burger').attr('aria-expanded', browseOpening ? 'true' : 'false');
      if(browseOpening){
        $('.side-nav .close').focus();
      } else {
        $('.header .burger').focus();
      }
    })
    .on('touchstart click', '[data-action=toggle-cart]', function(e){
      if(!e.ctrlKey && !e.metaKey && ajaxCart){
        if(e.type == "click") e.preventDefault();
        if(is_touch_device && e.type == "click") return;
        if(!is_touch_device && e.type == "touchstart") return;

        if($body.hasClass('shopping')){
          closeSideCart();
        } else {
          openSideCart();
          ajaxCart.load();
        }
      }
    })
    .on('touchstart click', '[data-action=toggle-search]', function(e){
      if(!e.ctrlKey && !e.metaKey){
        if(e.type == "click") e.preventDefault();
        if(is_touch_device && e.type == "click") return;
        if(!is_touch_device && e.type == "touchstart") return;

        $body.toggleClass('searching');
        if($body.hasClass('searching')){
          $('.search-overlay input.text').val('').focus();
        } else {
          $('.search-overlay input.text').blur();
          $('.predictive-search-results').empty();
        }
      }
    })
    .on('keyup', '.search-overlay input.text', function(e){
      var query = $(this).val(),
          searchBaseUrl = $(this).parents('form').attr('action'),
          $results = $('.predictive-search-results');

      // if option disabled
      if ($results.length === 0) {
        return;
      }

      // or not available because theme language
      if (shopifyFeatures = JSON.parse($('#shopify-features').html())) {
        if (!shopifyFeatures.predictiveSearch){
          return;
        }
      }

      // reset
      if (window.searchRequest) {
        window.searchRequest.abort();
      }

      if(query.length > 0) {
        window.searchRequest = $.getJSON(searchBaseUrl + "/suggest.json", {
          s: query,
          resources: {
            "type": "product",
            "limit": 4,
            "options": {
              "unavailable_products": "last"
            }
          }
        }).done(function(response) {
          var productSuggestions = response.resources.results.products;
          if (productSuggestions.length > 0) {
            var data = {},
                source = $("#CollectionProductsTemplate").html(),
                template = Handlebars.compile(source);

            data.products = [];
            $.each(productSuggestions, function(index, product) {
              product.on_sale = product.compare_at_price_min > product.price;
              product.price_varies = product.price_min != product.price_max;
              product.price = Colors.Currency.formatMoney(product.price, Colors.strings.money_format);
              product.compare_at_price = Colors.Currency.formatMoney(product.compare_at_price_min, Colors.strings.money_format);
              product.price_min = Colors.Currency.formatMoney(product.price_min, Colors.strings.money_format);
              product.price_max = Colors.Currency.formatMoney(product.price_max, Colors.strings.money_format);
              product.from_price = Colors.strings.from_price.slice(0).replace(/\{\{ lowest_price \}\}$/, product.price_min);
              if(product.image) {
                product.img = product.image.replace(/(\.[^.]*)$/, "_450x450$1").replace('http:', '');
                product.img_2x = product.image.replace(/(\.[^.]*)$/, "_450x450@2x$1").replace('http:', '');
                product.img_3x = product.image.replace(/(\.[^.]*)$/, "_450x450@3x$1").replace('http:', '');
              } else {
                product.img = "https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_590x.gif"
                product.img_2x = product.img;
                product.img_3x = product.img;
              }
              data.products.push(product);
            });
            $('.predictive-search-results').empty().append(template(data));
          }
        });
      } else {
        $('.predictive-search-results').empty();
      }
    })
    .on('keydown', '.search-overlay input.text', function(e){
      if(e.which === 13){
        if (window.searchRequest) {
          window.searchRequest.abort();
        }
      }
    })
    .on('keydown', 'body', function(e){
      if($body.hasClass('browsing') && e.which === 9){
        var $sn = $('.side-nav');
        var $closeBtn = $sn.find('.close')[0];
        var snFocusable = $sn.find('a[href], button, input, select, textarea').filter(':visible').not('.close').toArray();
        if(snFocusable.length && $closeBtn){
          var snFirst = snFocusable[0];
          var snLast = snFocusable[snFocusable.length - 1];
          if(e.shiftKey){
            if(document.activeElement === $closeBtn || document.activeElement === snFirst){
              e.preventDefault();
              snLast.focus();
            }
          } else {
            if(document.activeElement === snLast){
              e.preventDefault();
              $closeBtn.focus();
            }
          }
        }
      }
      if($body.hasClass('shopping') && e.which === 9){
        var $sc = $('.side-cart');
        var focusable = $sc.find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible').toArray();
        if(focusable.length === 0) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if(e.shiftKey){
          if(document.activeElement === first){
            e.preventDefault();
            last.focus();
          }
        } else {
          if(document.activeElement === last){
            e.preventDefault();
            first.focus();
          }
        }
      }
      if($body.hasClass('searching') && e.which === 27){
        $('[data-action=toggle-search]').first().click();
      }
      if($body.hasClass('browsing') && e.which === 27){
        $('[data-action=toggle-browse]').first().click();
      }
      if($body.hasClass('shopping') && e.which === 27){
        closeSideCart();
      }
      if(e.which == 9){
        $('body')
          .removeClass('no-outlines')
          .one('mousedown', function(){
            $(this).addClass('no-outlines');
          });
      }
      if(e.which == 13){
        var $activeElement = $(document.activeElement);
        if($activeElement.attr('data-action') === 'link-to-child-list' && $activeElement.closest('.side-nav').length){
          var handle = $activeElement.attr('data-handle');
          var $nav = $activeElement.parents('.nav');
          var $list = $('.' + handle, $nav);
          if($list.length > 0){
            var isExpanded = $activeElement.attr('aria-expanded') === 'true';
            $activeElement.attr('aria-expanded', isExpanded ? 'false' : 'true');
            $list.slideToggle(400, 'easeOutQuad', function(){
              if(!isExpanded){
                var $firstChild = $list.find('a[href], button').filter(':visible').first();
                if($firstChild.length){ $firstChild.focus(); }
              }
            });
          }
          e.preventDefault();
        }
        switch($activeElement.attr('data-action')){
          case 'toggle-browse':
            var browseOpening = !$body.hasClass('browsing');
            $document.trigger(browseOpening ? 'opening' : 'closing');
            $body.toggleClass('browsing');
            $('.header .burger').attr('aria-expanded', browseOpening ? 'true' : 'false');
            if(browseOpening){
              setTimeout(function(){ $('.side-nav .close').focus(); }, 50);
            } else {
              $('.header .burger').focus();
            }
            e.preventDefault();
            break;
          case 'toggle-cart':
            if(ajaxCart){
              if($body.hasClass('shopping')){
                closeSideCart();
              } else {
                openSideCart();
                ajaxCart.load();
              }
            } else {
              window.location = '/cart';
            }
            e.preventDefault();
            break;
          case 'toggle-search':
            window.location = '/search';
            e.preventDefault();
            break;
          case 'show-product':
            window.location = $activeElement.attr('href');
            e.preventDefault();
        }
      }
    })
    .on('keyup', 'body', function(e){
      if(e.which == 9){
        var $activeElement = $(document.activeElement);
        if(!$body.hasClass('browsing') && $activeElement.parents('.side-nav').length > 0){
          $('[data-action=toggle-browse]').first().click();
        }
        if ($body.hasClass('browsing') && $activeElement.parents('.side-nav').length == 0){
          $('[data-action=toggle-browse]').first().click();
        }
      }
    })
    .on('ajaxCart.afterCartLoad', function(evt, cart) {
      var $adminBar = $('#admin_bar_iframe')
          $items = $('.side-cart .items'),
          $more = $('.side-cart .more'),
          $additionalCheckoutButtons = $('.additional-checkout-buttons'),
          moreHeight = $more.outerHeight(),
          adminBarHeight = $adminBar.height();

      $items.css('bottom', moreHeight);

      if ($additionalCheckoutButtons.length > 0) {
        window.sideCartInterval = setInterval(function(){
          moreHeight = $more.outerHeight();
          $items.css('bottom', moreHeight);
        }, 2000);
      }

      if($adminBar.length > 0){
        if($adminBar.css('width') != "40px"){
          $more.css('bottom', adminBarHeight);
          $items.css('bottom', moreHeight + adminBarHeight);
        }
      }
      $items.scrollTop(window.cartScrollTop);
      $document.trigger('opening');
      openSideCart();
    })
    .on('closing', function(e){
      clearInterval(window.sideCartInterval);
    })
    .on('click', 'body.browsing .main', function(e){
      $document.trigger('closing');
      $body.removeClass('browsing');
      $('.header .burger').attr('aria-expanded', 'false').focus();
      e.preventDefault();
    })
    .on('click', 'body.shopping .main', function(e){
      closeSideCart();
      e.preventDefault();
    })
    .on('change', '[data-action=update-cart]', function(){
      $('input.update-cart').click();
    })
    .on('click', '.side-nav a:not([data-action])', function(e){
      if(!e.ctrlKey && !e.metaKey){
        $document.trigger('closing');
        $body.removeClass('browsing');
      }
    })
    .on('focus', 'form .error', function(e){
      $(this).one('keydown', function(e){
        $(this).removeClass('error');
      });
    })
    .on('touchstart click', '.side-nav [data-action=link-to-child-list][data-handle]', function(e){
      var $this = $(this),
          handle = $this.attr('data-handle'),
          $nav = $this.parents('.nav'),
          $list = $('.' + handle, $nav);

      e.preventDefault();
      if(is_touch_device && e.type == "click") return;
      if(!is_touch_device && e.type == "touchstart") return;

      if($list.length > 0){
        if($this.attr('aria-expanded') == "true") {
          $this.attr('aria-expanded', 'false');
        } else {
          $this.attr('aria-expanded', 'true');
        }
        $list.slideToggle(400, "easeOutQuad");
      }
    })
    .on((is_touch_device ? 'touchstart' : 'mouseenter') + ' click', '.header [data-action=link-to-child-list][data-handle]', function(e){
      var $this = $(this),
          handle = $this.attr('data-handle'),
          $nav = $this.parents('.nav'),
          $li = $this.parents('li'),
          $ul = $('ul.' + handle, $nav);

      e.preventDefault();

      if(is_touch_device && e.type == "click") return;

      var contract = function(){
        $ul.removeClass('expanded');
        $this.attr('aria-expanded', 'false');
        $(window).off('resize.submenu  scroll.submenu');
      };

      if($ul.length > 0){
        if(!$ul.hasClass('expanded')) {
          $('.header .expanded').parent('li').trigger('mouseleave');
          $ul.addClass('expanded');
          if($this.offset().left > $(window).outerWidth()/2) {
            $ul.addClass('right');
          }
          $this.attr('aria-expanded', 'true');
          $li.one('mouseleave', function(e){
            e.preventDefault();
            contract();
          });
          $(window).on('resize.submenu scroll.submenu', function(){
            contract();
          });
        } else if (e.type == "touchstart") {
          contract();
        }
      }
    })
    .on('click', '[data-action=add-new-address]', function(e){
      Shopify.CustomerAddress.toggleNewForm();
      e.preventDefault();
    })
    .on('click', '[data-action=hide-new-address]', function(e){
      Shopify.CustomerAddress.toggleNewForm();
      e.preventDefault();
    })
    .on('click', '[data-action=edit-address][data-address-id]', function(e){
      var address_id = $(this).data('address-id');
      Shopify.CustomerAddress.toggleForm(address_id);
      e.preventDefault();
    })
    .on('click', '[data-action=hide-edit-address][data-address-id]', function(e){
      var address_id = $(this).data('address-id');
      Shopify.CustomerAddress.toggleForm(address_id);
      e.preventDefault();
    })
    .on('change', '.template-cart .quantity input', function(e){
      var $this = $(this),
          $form = $('form.cart');

      clearTimeout(window.cartUpdateTimeout);
      window.cartUpdateTimeout = setTimeout(function(){
        var line = $this.parents('[data-line]').attr('data-line'),
            quantity = $this.val();

        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: 'quantity=' + quantity + '&line=' + line,
          dataType: 'json',
          success: function(data) {
            $.getJSON('/cart.js', function(cart) {
              $('p#cart-item-count').text(cart.item_count);
            } );
            $.get('/cart', function(data){
              var $newForm = $(data).find('form.cart');
              if($('.items .item', $newForm).length > 0 && !window.is_ie){
                $form.replaceWith($newForm);
                Colors.initShapes();
                qtySelectors();
              } else {
                window.location = '/cart';
              }
            });
          }
        });
        $this
          .prop('disabled', true)
          .fadeTo(0, 0.25);
      }, 1000);
    })
    .on('click', '[data-action=show-landing]', function(e){
      e.preventDefault();
      $('.landing').fadeIn();
      $('.login').hide();
    })
    .on('click', '[data-action=show-login]', function(e){
      e.preventDefault();
      $('.landing').hide();
      $('.login').fadeIn();
      if(!window.is_touch_device){
        $('.login input.password').focus();
      }
    });

  if(window.showPasswordLogin){
    $('[data-action=show-login]').first().trigger('click');
  }

  $('a[href="#"]').on('click', function(e) {
    e.preventDefault();
  });

};

Colors.initNewsletter = function() {
  if (location.search.indexOf('customer_posted=true') !== -1 || location.search.indexOf('contact%5Bemail%5D=') !== -1){
    setTimeout(function(){
      var offsetTop = 0;
      if($('.newsletter-section').length){
        offsetTop = $('.newsletter-section').offset().top;
      } else {
        offsetTop = $('.footer').offset().top;
      }

      $('body,html').animate({ scrollTop: offsetTop}, { duration: 0 });
    }, 1000);
  }
};

Colors.onFontsLoaded = function(){
  Colors.initShapes();
};

Colors.initShapes = function() {
  new Colors.Shapes();
};
